<template>
    <v-toolbar
      class="text-h6 bg-gray-light text-left px-4"
      :density="$vuetify.display.mdAndUp ? 'compact' : 'default'"
    >
      <!--        <span class="dark-primary pr-3">Мой профиль</span>-->
      <v-spacer/>
      <v-toolbar-items v-if="$vuetify.display.mdAndUp">
        <v-btn @click="$emit('open-avatar-form')"  class="dark-primary">
          <v-icon>aspect_ratio</v-icon>
          <span class="ml-3">Сменить аватар</span>
        </v-btn>
        <v-btn @click="$emit('open-password-form')" class="dark-primary">
          <v-icon>lock</v-icon>&nbsp;
          Сменить пароль
        </v-btn>
        <v-btn @click="$emit('open-email-form')" class="dark-primary">
          <v-icon>mail_outline</v-icon>&nbsp;
          Сменить почту
        </v-btn>
      </v-toolbar-items>
      <v-tooltip location="bottom" text="Режим редактирования">
        <template v-slot:activator="{ props }">
          <v-switch v-bind="props"
                    hide-details
                    inset
                    color="green-darken-1"
                    :model-value="edit"
                    @update:model-value="$emit('toggle-edit')"
                    class="medium-primary my-0">
            <v-icon :icon="(!!edit)?'edit_off':'edit'"></v-icon>
          </v-switch>
        </template>
      </v-tooltip>
      <v-menu v-if="$vuetify.display.smAndDown">
        <template v-slot:activator="{ props }">
          <v-btn icon="more_vert" v-bind="props" class="ml-1 mr-n3 dark-primary"></v-btn>
        </template>
        <v-list class="rounded-lg">
          <v-list-item>
            <v-btn elevation="0" block @click="$emit('open-avatar-form')" color="bg-gray-light">
              <v-icon>aspect_ratio</v-icon>
              <span class="ml-3">Сменить аватар</span>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn elevation="0" block @click="$emit('open-password-form')" color="bg-gray-light">
              <v-icon>lock</v-icon>&nbsp;
              Сменить пароль
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn elevation="0" block @click="$emit('open-email-form')" color="bg-gray-light">
              <v-icon>mail_outline</v-icon>&nbsp;
              Сменить почту
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
</template>

<script>
export default {
  name: 'HeaderToolbar',
  props: {
    edit: {
      type: Boolean,
      default: false
    },
  },
  emits: ['toggle-edit', 'open-avatar-form', 'open-password-form', 'open-email-form']
}
</script>
